export default {
  typeModuleIntro: 'Where Nerds come\ntogether to',
  intro:
    'We’re NerdWallet. And we’re not your typical finance company. We believe that everyone should be able to make financial decisions with confidence. We’re building a team of Nerds with the knowledge, passion, and skills to make that happen.',
  title: 'Our mission',
  body: "Our mission is to provide clarity for all of life's financial decisions.",
  splashImage:
    'https://www.nerdwallet.com/cdn/company/2021/splash/zoom-edit.png',
};
